import Chip from '@mui/material/Chip'
import { Link2Show } from 'lib/links'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  chip: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1)
  }
}))

export default function ChipShow ({ name, slug }) {
  const classes = useStyles()

  if (!name || !slug) return null

  return (
    <Link2Show slug={slug}>
      <Chip
        label={name}
        variant='outlined'
        component='a'
        clickable
        data-test='chip-series'
        title={'Sendung: ' + name}
        className={classes.chip}
      />
    </Link2Show>
  )
}
